module.exports = __webpack_public_path__ + "img/taucherbrille_px.b082d459.png";